import React from 'react';
import { pathname, is8DataApp } from '../../../../utils';
import { useLocation, useHistory } from 'react-router-dom';
import { useCompanyContext } from '../../../../contexts/Company';
import { useOnboardingContext } from '../../../../contexts/Onboarding';
import { ESellerStore as Platform } from '../../../../Types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  backButton: {
    marginRight: theme.spacing(1),
  },
  button: {
    minWidth: 130,
    fontSize: theme.fontSizes.onboarding,
    position: 'relative',
  },
}));

const mainOnboardingPages = pathname.onboarding.main;
const extraOnboardingPages = pathname.onboarding.extras;

export default function BackButton() {
  const history = useHistory();
  const location = useLocation();

  const { activeStep, setActiveStep, goBack } = useOnboardingContext();
  const { business } = useCompanyContext();

  const classes = useStyles();

  function handleBackOnStoreUrlPage() {
    // EXTRA HANDLING FOR DIFFERENT ROUTES FROM THIS PAGE DEPENDING ON USER CHOICES
    if (business.sellerStore === Platform.amazon) {
      setActiveStep(mainOnboardingPages.sellerId.stepInStepper);
      return history.push(mainOnboardingPages.sellerId.url);
    } else {
      const prevPage = mainOnboardingPages?.eightFigExplanation;
      setActiveStep(prevPage?.stepInStepper);
      return history.push(prevPage?.url);
    }
  }

  function handleBackOnProductNamePage() {
    // EXTRA HANDLING FOR DIFFERENT ROUTES FROM THIS PAGE DEPENDING ON USER CHOICES
    if (business.sellerStore === Platform.amazon) {
      setActiveStep(mainOnboardingPages.product.stepInStepper);
      return history.push(mainOnboardingPages.product.url);
    } else {
      return history.push(extraOnboardingPages.productUrl.url);
    }
  }

  function handleBackOnCompanyNamePage() {
    setActiveStep(extraOnboardingPages.storeUrl.url);
    return history.push(extraOnboardingPages.storeUrl.url);
  }

  function handleBackOnProductUrlPage() {
    const prevPage = extraOnboardingPages.companyName;
    setActiveStep(prevPage.stepInStepper);
    history.push(prevPage.url);
  }

  const handleBack = () => {
    if (location.pathname === extraOnboardingPages.storeUrl.url) {
      return handleBackOnStoreUrlPage();
    }
    if (location.pathname === extraOnboardingPages.companyName.url) {
      return handleBackOnCompanyNamePage();
    }
    if (location.pathname === extraOnboardingPages.productUrl.url) {
      return handleBackOnProductUrlPage();
    }
    if (location.pathname === mainOnboardingPages.productName.url) {
      return handleBackOnProductNamePage();
    }
    goBack();
  };

  const handleBack8Data = () => {
    goBack();
  };

  return (
    <Button
      disabled={activeStep === 1}
      onClick={is8DataApp() ? handleBack8Data : handleBack}
      className={classes.button + ' ' + classes.backButton}
    >
      Back
    </Button>
  );
}
